import { StorageDataAbbreviation } from '../types'

export const getIndexedLabel = (label: string, index: number, count: number): string => {
  return count > 1 ? `${label} (${index + 1})` : label
}

export const getActionTargetAriaLabel = (label: string, objectLabel: string): string => {
  return `${label} ${objectLabel}`
}

export const formatBytes = (bytes: number, decimals: number, abbreviation: StorageDataAbbreviation): string => {
  if (!bytes) {
    return `0 ${abbreviation.bytes}`
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = [abbreviation.bytes, abbreviation.kilobytes, abbreviation.megabytes]

  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1)

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
